import { FormFooter as BaseFormFooter, FormFooterCancel } from 'components';
import { useTranslation } from 'libs/i18n';
import { Button } from 'libs/ui';

export interface FormFooterProps {
  submitLabel?: string;
  editable?: boolean;
  submitDisabled?: boolean;
  submitLoading?: boolean;
  onSubmit?: () => void;
  onCancel?: () => void;
}

export const FormFooter = ({
  submitLabel,
  submitDisabled,
  submitLoading,
  editable,
  onSubmit,
  onCancel,
}: FormFooterProps) => {
  const { t } = useTranslation();

  return (
    <BaseFormFooter visible={editable}>
      <FormFooterCancel label={submitLabel} onClick={onCancel} />
      <Button
        disabled={submitDisabled}
        label={submitLabel ?? t('common.save')}
        loading={submitLoading}
        sizeVariant="m"
        onClick={onSubmit}
      />
    </BaseFormFooter>
  );
};
